var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPlus(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 10.735,
    height: 10.735,
    "view-box": "0 0 10.735 10.735",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-172.823 -302.091) rotate(45)"
  }, /*#__PURE__*/React.createElement("line", {
    stroke: "#5d78ff",
    y2: 9.735,
    transform: "translate(346.848 87.964) rotate(45)"
  }), /*#__PURE__*/React.createElement("line", {
    stroke: "#5d78ff",
    y2: 9.735,
    transform: "translate(346.848 94.848) rotate(135)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlus);
export default __webpack_public_path__ + "static/media/plus.e9b000c7d6c9211b248d3300a166e5ef.svg";
export { ForwardRef as ReactComponent };